import {ILangdict, Langdict} from './langdict';
import {IUser, User} from './user';
import {environment} from '../../environments/environment';

class IWeeklyMeetingOption {
  'hourBegin': number;
  'minuteEnd': number;
  'hourEnd': number;
  'day': string;
  'minuteBegin': number;
}

export enum DayOfWeek {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday'
}

class WeeklyMeetingOption extends IWeeklyMeetingOption {

  day: DayOfWeek;

  constructor(obj: IWeeklyMeetingOption) {
    super();
    Object.assign(this, obj);
  }

}

class IWeeklyMeeting {
  room: {
    id: number,
    number: string;
    building: {
      id: string;
      name: ILangdict;
      address: {
        city: string,
        houseNumber: string,
        street: string,
      }
      usoswebURL: string;
    }
  };
  weeklyMeetingOption: IWeeklyMeetingOption;
}

class WeeklyMeeting extends IWeeklyMeeting {
  weeklyMeetingOption: WeeklyMeetingOption;

  constructor(obj: IWeeklyMeeting) {
    super();
    Object.assign(this, obj);
    this.weeklyMeetingOption = new WeeklyMeetingOption(obj.weeklyMeetingOption);
    if (obj.room && obj.room.building) {
      this.room.building.name = new Langdict(obj.room.building.name);
      this.room.building.usoswebURL = environment.usoswebUrl + 'kontroler.php?_action=katalog2/jednostki/pokazBudynek&bud_kod=' + this.room.building.id;
    }
  }
}

export class IDedication {
  programme?: { id: string, description: ILangdict };
  sex?: "Female" | "Male"
}

export class Dedication extends IDedication {
  constructor(obj: IDedication) {
    super();
    if (obj.programme) {
      this.programme = {id: obj.programme.id, description: new Langdict(obj.programme.description)};
    }
    this.sex = obj.sex
  }
}

export class IClassGroup {
  number: number;
  lecturers: IUser[];
  description: ILangdict;
  weeklyMeetings: IWeeklyMeeting[];
  capacity: number;
  dedications: IDedication[];
  bibliography?: ILangdict;
}


export class ClassGroup extends IClassGroup {
  lecturers: User[];
  weeklyMeetings: WeeklyMeeting[];
  description: Langdict;

  constructor(obj: IClassGroup) {
    super();
    Object.assign(this, obj);
    this.lecturers = obj.lecturers.map(u => new User(u));
    this.weeklyMeetings = obj.weeklyMeetings.map(m => new WeeklyMeeting(m));
    this.dedications = obj.dedications.map(d => new Dedication(d));
    this.description = new Langdict(obj.description);
    this.bibliography = obj.bibliography ? new Langdict(obj.bibliography) : null;
  }

  name() {
    return new Langdict({pl: 'gr. ' + this.number, en: 'gr. ' + this.number});
  }

  getPathFragment() {
    return [this.number];
  }
}
